// @flow
import React, { useState } from 'react';
import { useHistory, useRouteMatch } from 'react-router';
import {
    Box, Button, Stack, Text,
} from 'grommet';
import { FILTER_OBJECTS_PANEL_KEY } from 'esm-web-pro/containers/map/filterobjects/FilterObjectsContainer';
import { useDispatch } from 'react-redux';
import { closePanel, openPanel } from 'esm-web-pro/redux/side-panel';
import Filter from 'esm-web-pro/components/tables/Filter';
import { isEqual } from 'lodash';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';


const StyledButton = styled(Button)`
  height: 56px;
`;

const FilterObjectsControl = () => {
    const [toggle, setToggle] = useState(true);
    const [filtersCount, setFiltersCount] = useState(0);

    const history = useHistory();
    const match = useRouteMatch();

    const dispatch = useDispatch();

    React.useEffect(() => {
        const { pathname } = history.location;
        const filtersCountStorage = window.sessionStorage.getItem('mapFiltersCount');

        // Change toggle if close button is hit from the side panel
        if (pathname.endsWith('filter/')) {
            setToggle(false);
        } else {
            setToggle(true);
        }

        // Get filters count from session storage
        if (filtersCountStorage) {
            if (!isEqual(+filtersCountStorage, filtersCount)) {
                setFiltersCount(JSON.parse(window.sessionStorage.getItem('mapFiltersCount')));
            }
        } else {
            setFiltersCount(0);
        }
    }, [match]);

    const filterObjectsPanelTitle = (
        <FormattedMessage
            id="filter-objects-title"
            defaultMessage="Filter objects"
        />
    );

    const handleOpen = () => {
        if (match.params.mapIdentity) {
            history.push(`${match.url.split('/layer')[0]}/filter/`);
            dispatch(openPanel(FILTER_OBJECTS_PANEL_KEY, filterObjectsPanelTitle, true));
            setToggle(false);
        }
    };

    const handleClose = () => {
        history.push(match.url.split('/filter')[0]);
        dispatch(closePanel(FILTER_OBJECTS_PANEL_KEY, true));
        setToggle(true);
    };

    return (
        <React.Fragment>
            <StyledButton
                onClick={toggle ? handleOpen : handleClose}
                hoverIndicator="light-1"
                pad={{ vertical: '10px', horizontal: 'small' }}
            >
                <Box pad={{ vertical: '10px', horizontal: 'small' }}>
                    <Stack
                        anchor="top-left"
                    >
                        <Box>
                            <Filter />
                        </Box>
                        {(filtersCount !== 0) && (
                            <Box
                                background="red"
                                pad={{ horizontal: '4px' }}
                                round
                                style={{ position: 'relative', top: '-5px', left: '-2px' }}
                            >
                                <Text weight="bold" color="white" size="10px">{filtersCount}</Text>
                            </Box>
                        )}
                    </Stack>
                </Box>
            </StyledButton>
        </React.Fragment>
    );
};

export default FilterObjectsControl;
